import { DataModel, DataModelBuilder, SerializationContext, SerializedData, isSameData } from '../../dto/dto.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { PromoCodeProtocol, PromoCodeProtocolType } from './promo-code-protocol.js';
import { Price } from '../price.js';

export class DownToPricePromoCodeProtocol extends PromoCodeProtocol {
  static readonly TYPE_ID: string = '67d3268a7b9445c09b7876de91cc951a';

  public readonly type: PromoCodeProtocolType = PromoCodeProtocolType.DownToPrice;

  constructor(
    public readonly price: Price,
  ) {
    super();
  }

  get $typeId(): string {
    return DownToPricePromoCodeProtocol.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): DownToPricePromoCodeProtocol {
    return new DownToPricePromoCodeProtocol(
        Price.decode(MapUtils.get<string>(map, 'price')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'price': this.price.encode(),
    };
  }

  clone(): this {
    return new DownToPricePromoCodeProtocol(
        this.price.clone(),
    ) as this;
  }

  isSame(other: DownToPricePromoCodeProtocol): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.price, this.price);
  }

  calculateDiscount(originalPrice: Price): Price {
    if(originalPrice.currency != this.price.currency || originalPrice.compareTo(this.price) <= 0) {
      return Price.zero(originalPrice.currency);
    }

    return originalPrice.difference(this.price);
  }

  static verifyType(dm: DataModel): boolean {
    return dm instanceof DownToPricePromoCodeProtocol;
  }

  static assertType(dm: DataModel): dm is DownToPricePromoCodeProtocol {
    return dm instanceof DownToPricePromoCodeProtocol;
  }
}

export class DownToPricePromoCodeProtocolBuilder extends DataModelBuilder<DownToPricePromoCodeProtocol> {
  build(context: SerializationContext, map: SerializedData): DownToPricePromoCodeProtocol {
    return DownToPricePromoCodeProtocol.fromMap(context, map);
  }
}
